import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hennikerConfig } from "./data";

export default function HennikerPage() {
  return <CityPageTemplate config={hennikerConfig} />;
}